import NanduModal from './NanduModal';

export default NanduModal;
